var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"Logo",attrs:{"alt":"Logo","src":_vm.logoPath,"onerror":"this.src='/img/logo.png';this.onerror='';"}})}
var staticRenderFns = []

export { render, staticRenderFns }